import { z } from 'zod';
import { NullableJsonValue } from "../inputTypeSchemas/NullableJsonValue"

/////////////////////////////////////////
// BRANDED APP JOBS SCHEMA
/////////////////////////////////////////

export const branded_app_jobsSchema = z.object({
  id: z.bigint(),
  step: z.string().nullable(),
  site_name: z.string().nullable(),
  mode: z.string().nullable(),
  platform: z.string().nullable(),
  app_version: z.string().nullable(),
  job_status: z.string().nullable(),
  retry_count: z.number().int().nullable(),
  last_error_message: z.string().nullable(),
  run_at: z.coerce.date().nullable(),
  job_id: z.string().nullable(),
  data: NullableJsonValue.optional(),
  created_at: z.coerce.date(),
  updated_at: z.coerce.date(),
})

export type branded_app_jobs = z.infer<typeof branded_app_jobsSchema>

export default branded_app_jobsSchema;
